import { strToDom } from 'minsky-kit/js/utils/dom';

export function renderLoader (args = {}) {
    const classes = [
        'machine-loader',
        `machine-loader--${args.type || 'default'}`,
    ].concat(args.classes || {});

    const html = `
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 714 714" class="${classes.join(' ')}">
    <defs>
      <circle id="a" cx="336" cy="336" r="336"/>
    </defs>
    <g fill="none" fill-rule="evenodd">
      <g class="machine-loader__basket" stroke-width="10">
        <g transform="translate(145 116)">
          <circle cx="211.5" cy="240.5" r="9.5" transform="matrix(-1 0 0 1 423 0)"/>
          <circle cx="161.5" cy="269.5" r="9.5" transform="matrix(-1 0 0 1 323 0)"/>
          <circle cx="111.5" cy="298.5" r="9.5" transform="matrix(-1 0 0 1 223 0)"/>
          <circle cx="61.5" cy="327.5" r="9.5" transform="matrix(-1 0 0 1 123 0)"/>
          <circle cx="11.5" cy="356.5" r="9.5" transform="matrix(-1 0 0 1 23 0)"/>
          <circle cx="260.5" cy="269.5" r="9.5" transform="matrix(-1 0 0 1 521 0)"/>
          <circle cx="309.5" cy="298.5" r="9.5" transform="matrix(-1 0 0 1 619 0)"/>
          <circle cx="358.5" cy="327.5" r="9.5" transform="matrix(-1 0 0 1 717 0)"/>
          <circle cx="407.5" cy="356.5" r="9.5" transform="matrix(-1 0 0 1 815 0)"/>
          <circle cx="211.5" cy="183.5" r="9.5" transform="matrix(-1 0 0 1 423 0)"/>
          <circle cx="211.5" cy="126.5" r="9.5" transform="matrix(-1 0 0 1 423 0)"/>
          <circle cx="211.5" cy="68.5" r="9.5" transform="matrix(-1 0 0 1 423 0)"/>
          <circle cx="211.5" cy="11.5" r="9.5" transform="matrix(-1 0 0 1 423 0)"/>
        </g>
        <path stroke-dasharray="10 15" d="M357 712a355 355 0 1 0 0-710 355 355 0 0 0 0 710Z"/>
      </g>
      <g transform="translate(16 21)">
        <mask id="b" fill="#fff">
          <use xlink:href="#a"/>
        </mask>
        <g mask="url(#b)">
          <path class="machine-loader__water" fill="#003451" fill-rule="nonzero" d="M1136.3 360h1v641.4H-.5V360.1c35.7-1 104 4 186.8 43.5l2.5 1.2c115.2 56 265.6 102.4 376 102.2h6.6c109.3.2 257.8-45.4 372.6-100.5l6-2.9c82.4-39.4 150.5-44.5 186.3-43.6Zm1137.8 0h1v641.4H1137.4V360.1c35.8-1 104 4 186.8 43.5l2.5 1.2c115.2 56 265.6 102.4 376 102.2h6.6c109.4.2 257.8-45.4 372.6-100.5l6-2.9c82.5-39.4 150.5-44.5 186.3-43.6Zm1137.8 0h1v641.4H2275.3V360.1c35.7-1 103.9 4 186.7 43.5l2.5 1.2c115.2 56 265.6 102.4 376 102.2h6.6c109.3.2 257.7-45.4 372.5-100.5l6-2.9c82.5-39.4 150.5-44.5 186.3-43.6Z"/>
        </g>
      </g>
    </g>
  </svg>`;

    return strToDom(html);
}
